import React, { Component } from "react";
import { connect } from "react-redux";

import { RootState } from "../../store/reducer";
import { Dispatch, bindActionCreators } from "redux";
import { setFormData, setFormErrors } from "src/store/form/actions";

import { getId } from "../../store/thunkCertificateAppeal";
import { castThunkAction } from "src/helpers/casting";
import Hotel from "./newDesgins/hotel";

interface OwnProps {
  certificateGuid: string;
}

interface OwnState {
  lang: boolean;
  responsefinish: boolean;
}

function mapStateToProps(state: RootState) {
  return {
    language: state.system.language,
    formData: state.form.formData,
    formErrors: state.form.formErrors,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    ...bindActionCreators(
      {
        setFormData,
        setFormErrors,
        getId,
      },
      dispatch,
    ),
  };
}

type MainPageProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

class MainPage extends Component<MainPageProps, OwnState> {
  state = {
    lang: true,
    responsefinish: false,
  };

  componentDidMount() {
    if (this.props.certificateGuid) {
      castThunkAction(this.props.getId(this.props.certificateGuid))
        .then((response: any) => {
          this.setState({ responsefinish: true });
        })
        .catch((err: any) => {
          if (err.status === 404) {
            window.location.href = "/Error/ErrorNotFound";
          }
        });
    }
  }

  render() {
    const { formData } = this.props;

    return formData?.data ? (
      <Hotel data={formData} lang={this.state.lang} />
    ) : (
      <div></div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
